import { PortalUser, GrantSummary } from "@/contexts/AuthContext";

export interface PortalCapabilities {
  browseUsers: boolean;
  manageUsers: boolean;
  viewAuditLog: boolean;
  viewClients: boolean;
}

export interface PortalUserContext {
  isVidivetAdmin: boolean;
  isVidivetUser: boolean;
  isVidivetStaff: boolean;
  isCustomerAdmin: boolean;
  adminPartners: string[];
  canUser: PortalCapabilities;
}

export function getPortalUserContext(
  user: PortalUser | null | undefined,
  activeGrant?: GrantSummary | null,
): PortalUserContext {
  const isVidivetAdmin = user?.internalRole === "VIDIVET_ADMIN";
  const isVidivetUser = user?.internalRole === "VIDIVET_USER";
  const isVidivetStaff = isVidivetAdmin || isVidivetUser;
  const adminPartners = (user?.grants ?? [])
    .filter((g) => g.partnerRole === "CUSTOMER_ADMIN")
    .map((g) => g.partnerCode);

  const isCustomerAdminOnActivePartner =
    !isVidivetStaff && activeGrant?.partnerRole === "CUSTOMER_ADMIN";

  const isCustomerAdmin = isCustomerAdminOnActivePartner;

  return {
    isVidivetAdmin,
    isVidivetUser,
    isVidivetStaff,
    isCustomerAdmin,
    adminPartners,
    canUser: {
      browseUsers: isVidivetStaff || isCustomerAdmin,
      manageUsers: isVidivetAdmin || isCustomerAdmin,
      viewAuditLog: isVidivetStaff || isCustomerAdmin,
      viewClients: isVidivetStaff || (user?.grants?.length ?? 0) > 0,
    },
  };
}
